import React, { useReducer, useState } from "react"
import PropTypes from "prop-types"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import Alerts from "../Alerts"

// Styles, images
import * as styles from "./Styles/SigninForm.module.scss"
import "../../styles/layouts"
import "../../styles/full_height"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)
import logo from "../../images/logo_black.png"

const ResetPasswordModal = (props) => {
  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      className={styles.resetPasswordModal}
    >
      <Modal.Header>パスワード再設定</Modal.Header>
      <Modal.Body>
        <Form action="/reset_password_mails" method="post">
          <Form.Control
            type="email"
            placeholder="メールアドレス"
            name="email"
            className={styles.resetPasswordMail}
          />
          <input type="hidden" name="authenticity_token" value={props.token} />
          <Button variant="primary" type="submit" className={styles.formButton}>
            パスワード再設定メールを送信
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

const SigninForm = (props) => {
  const [modalShow, setModalShow] = useState(false)
  const [user, dispatchUser] = useReducer(userReducer, props.user)

  function userReducer(user, action) {
    switch (action.type) {
      case "email":
        return { ...user, email: action.value }
      case "password":
        return { ...user, password: action.value }
      default:
        return user
    }
  }

  return (
    <React.Fragment>
      <Alerts error={props.error} notice={props.notice} />
      <div className={cn("l-centering", "l-flex--column", "container")}>
        <img src={logo} alt="logo" className={styles.serviceLogo} />
        <Form action={props.formPath} method="post" className={styles.form}>
          <Form.Group controlId="signInForm.email">
            <Form.Control
              type="email"
              placeholder="name@example.com"
              name="email"
              value={user.email ? user.email : ""}
              onChange={(e) =>
                dispatchUser({ type: "email", value: e.target.value })
              }
            />
          </Form.Group>
          <Form.Group controlId="signInForm.password">
            <Form.Label>パスワード</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              name="password"
              autoComplete="current-password"
              onChange={(e) =>
                dispatchUser({ type: "password", value: e.target.value })
              }
            />
          </Form.Group>
          <input type="hidden" name="authenticity_token" value={props.token} />
          {props.redirect && (
            <input type="hidden" name="rt" value={props.redirect} />
          )}
          <Button variant="primary" type="submit" className={styles.formButton}>
            ログイン
          </Button>
        </Form>
        <div className={styles.links}>
          <p>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                setModalShow(true)
              }}
            >
              パスワードを忘れた方はこちら
            </a>
          </p>
          <p>
            <a href={props.signupPath}>新規登録はこちら</a>
          </p>
        </div>
      </div>
      <ResetPasswordModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        {...props}
      />
    </React.Fragment>
  )
}
SigninForm.propTypes = {
  user: PropTypes.object,
  formPath: PropTypes.string,
  token: PropTypes.string,
  error: PropTypes.string,
  notice: PropTypes.string,
  signupPath: PropTypes.string,
}
export default SigninForm
